export default __webpack_public_path__ + "static/media/yandex.582f368a.svg";